(function () {
  function openDoranBackInStock() {
    var app = document.getElementById('bp-app');
    if (!app) return false;

    var launcher = Array.prototype.slice.call(app.querySelectorAll('button, [role="button"]')).find(function (element) {
      var text = (element.textContent || '').trim();
      var rect = element.getBoundingClientRect();
      return /notify me when available/i.test(text) && rect.width > 0 && rect.height > 0 && !element.closest('form');
    });

    if (!launcher) return false;
    launcher.click();
    setTimeout(function () {
      if (!app.querySelector('form.dr-bis-form')) launcher.click();
    }, 350);
    return true;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-product-notify-trigger]');
    if (!trigger) return;

    var form = trigger.closest('[data-product-notify]').querySelector('[data-product-notify-form]');
    if (!form) return;
    form.hidden = !form.hidden;
    if (!form.hidden) {
      var input = form.querySelector('input[type="email"]');
      if (input) input.focus();
    }
  });
})();
